/** One retained-source projection for server persistence and browser acknowledgement comparison. */
import { canonicalJson } from '@testfeed/core';
import { studyAuthoringDraftSchema } from './shopify-study-authoring-operation.js';
/**
 * Frozen hash preimage only: existing creation/retry and accepted projection receipts must survive
 * removing the wire marker. Never serialize this as authoring. Parse first so obsolete/unknown
 * wire fields are rejected, not silently overwritten. See #4354 D15; seeded historical receipts
 * require an explicit migration because their former variable rule version cannot be guessed.
 */
export function studyAuthoringDraftHashInput(draft) {
    return { ...studyAuthoringDraftSchema.parse(draft), schemaVersion: 'shopify-study-builder-draft.v1' };
}
export function retainStudyAuthoringSource(draft, previous) {
    const next = { ...draft };
    for (const key of ['opportunitySeed', 'insightSetupSeed', 'nextTestSeed']) {
        if (draft[key] !== undefined && canonicalJson(draft[key]) !== canonicalJson(previous[key] ?? null))
            return { success: false, message: 'Seed provenance cannot be changed.' };
        if (previous[key] !== undefined)
            Object.assign(next, { [key]: previous[key] });
    }
    if (previous.productSelectionLocked) {
        // The lock fixes the PRODUCT only; the colour is always the merchant's choice, on locked drafts too.
        if (draft.selectedProductId !== previous.selectedProductId)
            return { success: false, message: 'The product for this study is locked.' };
        next.productSelectionLocked = true;
        // Pin the stored product copy (currency, title, media, variant list) so a client cannot overwrite it on a locked draft.
        // The whole copy comes from the stored draft. It only feeds display: the builder shows the server's projection of the
        // stored product pick, and Prepare and Submit read that pick, never this copy and never Shopify.
        if (previous.selectedProduct)
            next.selectedProduct = previous.selectedProduct;
    }
    return { success: true, draft: next };
}
//# sourceMappingURL=study-authoring-source.js.map